import * as api from './constants'
import {
  serviceReportingSuccessCallback,
  serviceReportingErrorCallback
} from './callbacks'
const store = require('store')

import {SYNC_BILL_SERVICE_URL} from 'api/syncBill/constants'

export function dashboard (query) {
  if (!loggedIn()) return Promise.reject(new Error('Not logged in'))
  return axios
    .get(api.GET_DASHBOARD, { params: query, withCredentials: true })
    .then(serviceReportingSuccessCallback)
    .catch(serviceReportingErrorCallback)
}
/* --- async dashboard --- */
export function getTableDashboard (params) {
  return axios.get(`${SYNC_BILL_SERVICE_URL}/bills/stats`, {params, withCredentials: false})
    .then(serviceReportingSuccessCallback)
    .catch(serviceReportingErrorCallback)
}

export function dashboardPost (queryPost) {
  return axios
    .post(api.GET_DASHBOARD_POST, queryPost, {withCredentials: false})
    .then(serviceReportingSuccessCallback)
    .catch(serviceReportingErrorCallback)
}

export function dashboardSummaryPost (dataPost) {
  return axios
    .post(api.GET_DASHBOARD_SUMMARY_POST, dataPost, {withCredentials: false})
    .then(serviceReportingSuccessCallback)
    .catch(serviceReportingErrorCallback)
}

export function getDataAsync (urls3) {
  if (!loggedIn()) return Promise.reject(new Error('Not logged in'))
  return axios
    .get(urls3, {'headers': {'Content-Encoding': 'gzip'}})
    .then(serviceReportingSuccessCallback)
    .catch(serviceReportingErrorCallback)
}

export function loggedIn () {
  const loggedInData = store.get('response:login')
  const cookiesData = Cookies.get('remember_token')

  if (isLocalStorageNameSupported()) {
    if (!loggedInData || !cookiesData) {
      resetLoggedIn()
      return false
    }

    try {
      JSON.parse(loggedInData).user
      return true
    } catch (e) {
      resetLoggedIn()
      return false
    }
  } else {
    if (!cookiesData) {
      resetLoggedIn()
      return false
    } else {
      return true
    }
  }
}

function resetLoggedIn () {
  Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' })
  store.clearAll()
}

function isLocalStorageNameSupported () {
  let testKey = 'test'
  let storage = window.localStorage
  try {
    storage.setItem(testKey, '1')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}



// WEBPACK FOOTER //
// ./app/api/dashboard.js